import React, { FC, useState } from 'react'
import { ContactDialog } from '../Subscription/components/ContactDialog'
import { Card } from 'components/Card'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { Heading } from 'components/Heading'
import { useTranslation } from 'react-i18next'
import { Icon } from 'components/Icon'
import { Flex } from 'components/Flex'
import { Button } from 'components/Button'
import styles from './Addons.module.scss'
import { formatPrice } from 'utils/currency'

export const ADDONS = [
  { type: 'predictive_report', price: 250, icon: 'file-chart-line' },
  { type: 'mobility_report', price: 200, icon: 'base-station-line' },
  { type: 'predictive_model', price: 100, icon: 'treasure-map-line' },
  { type: 'custom_layer', price: 20, icon: 'pencil-ruler-2-line' },
]

export const Addons: FC = () => {
  const { t } = useTranslation()
  const [contactModalOpen, setContactModalOpen] = useState(false)

  return (
    <>
      <Card>
        <Stack space="xlarge">
          <div>
            <Heading>{t('addons.title')}</Heading>
            <Text>{t('addons.description')}</Text>
          </div>

          <div className={styles.addons}>
            {ADDONS.map((addon) => (
              <Card key={addon.type}>
                <Flex direction="vertical" gap="md" fullHeight>
                  <Heading className={styles.addonTitle} size="widget">
                    <Flex align="center" component="span" gap="sm">
                      <Icon name={addon.icon} />
                      <span>{t(`addons.${addon.type}.title`)}</span>
                    </Flex>
                  </Heading>

                  <Text className={styles.addonDescription}>{t(`addons.${addon.type}.desc`)}</Text>

                  <Flex justify="between" align="center">
                    <Text
                      className={styles.addonTitle}
                      size="large"
                      weight="strong"
                      data-testid={`${addon.type}-price`}
                    >
                      {formatPrice(addon.price)}
                    </Text>
                    <Button onClick={() => setContactModalOpen(true)}>
                      {t('addons.purchase')}
                    </Button>
                  </Flex>
                </Flex>
              </Card>
            ))}
          </div>
        </Stack>
      </Card>

      <ContactDialog
        isOpen={contactModalOpen}
        action="addons"
        closeDialog={() => setContactModalOpen(false)}
      />
    </>
  )
}

Addons.displayName = 'Addons'
